module.exports = __webpack_public_path__ + "static/media/office5.1927e135.jpg";